import { BASE_URL } from './common';

export class MailService {

  private authHeader: string;
  private user: string;

  constructor(user: string, wsid: string, csrf: string) {
    this.user = user;
    this.authHeader = btoa(wsid + ':' + csrf);
  }

  public async list(pg: number, pgSize: number, order: string, field: string) {
    const params = { page: pg, pageSize: pgSize, sortOrder: order, sortField: field };
    const url = `${BASE_URL}/users/${this.user}/messages?page=${params.page}&pageSize=${pgSize}&sortOrder=${order}&sortField=${field}`;
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    return response;
  }

  public async getDetails(messageId: string) {
    const url = `${BASE_URL}/users/${this.user}/messages/${messageId}`;
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    return response;
  }

  public async release(messageId: string) {
    const url = `${BASE_URL}/users/${this.user}/messages/${messageId}/release`;
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    return response;
  }

  public async delete(messageId: string) {
    const url = `${BASE_URL}/users/${this.user}/messages/${messageId}`;
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic ' + this.authHeader,
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    });

    return response;
  }
}


// WEBPACK FOOTER //
// ./src/services/mail.ts